import { connect } from 'react-redux';
import { setHoveredRevisionComment } from 'presentations/ducks';
import RevisionComments from 'presentations/components/revision_comments';

const mapStateToProps = (state) => {
  const { hoveredRevisionCommentId, revisionComments } = state.project.presentations;

  return {
    hoveredCommentId: hoveredRevisionCommentId,
    comments: revisionComments || []
  };
}

export default connect(mapStateToProps, {
  setHoveredComment: setHoveredRevisionComment
})(RevisionComments);



// WEBPACK FOOTER //
// ./presentations/containers/revision_comments.js